export enum CommunityGroupsDataIndex {
  'name' = 'name',
  'created_at' = 'created_at',
  'updated_at' = 'updated_at',
}
